
import { Vue } from "vue-class-component"; // Only Vue, no @Component decorator
import { ref, reactive } from "vue"; // Vue Composition API functions
import EReceiptService from '../../service/EReceiptService';  // Adjust the path accordingly
import { useStore } from "../../store";
export default class ReceiptComponent extends Vue {
  public store = useStore();
  // Reactive properties
  receiptContainer = ref<HTMLElement | null>(null);
  // currency = "LKR";
  receiptInfo = reactive({
    branch_name: "",
    address: "",
    licenseNo: "ABC123456",
    telephone: "",
    receipt_no: "",
    type: "",
    customerName: "",
    msisdn: "",
    date_time: "",
    payment_type: "",
    empId: "Emp001",
    items: [
      {
        item_name: "",
        total_unit: "",
        mrp: "",
        sub_total: "",
        generic_name: "",
      },
    ],
    sub_total: "",
    total_discount:"" ,
    total_tax: "",
    total: "",
    invoicePayment: [{  transTotalAmount: "" }],
   
    tendered: "",
    change: "",
  });

  get currency() {
    return this.store.getters.getCurrency;
  }

  // Methods
  updateReceiptNumberFromUrl() {
    const path = window.location.pathname;
    const match = path.match(/receipt\/(.*)/);
    if (match && match[1]) {
      this.receiptInfo.receipt_no = match[1];
    }
  }

  fetchReceiptData() {
  const path = window.location.pathname;
  const match = path.match(/receipt\/(.*)/);

  if (match && match[1]) {
    const receiptId = match[1]; // Extract the receipt ID

    EReceiptService.fetchReceiptById(receiptId)
      .then((res) => {
        

        if (res && res.receiptInfo) {

          Object.assign(this.receiptInfo, {
            ...res.receiptInfo,
            items: res.receiptInfo.items.map((item: any) => ({
              item_name: item.item_name || "",
              total_unit: item.total_unit || item.total_unit || "",
              mrp: item.mrp || "",
              sub_total: item.sub_total || item.sub_total || "",
              generic_name: item.generic_name || "",
            })),
          });

          
        } else if (res) {

          Object.assign(this.receiptInfo, {
            ...res,
            items: res.items.map((item: any) => ({
              item_name: item.item_name || "",
              total_unit: item.total_unit || item.unit || "",
              mrp: item.mrp || "",
              sub_total: item.sub_total || item.sub_total || "",
              generic_name: item.generic_name || "",
            })),
          });

          
        } else {
          
        }
      })
      .catch((error) => {
       
      });
  } else {
    
  }
}

printReceipt() {
  // Ensure the receipt container exists
  if (!this.$refs.receiptContainer) return;

  // Open a new window for printing
  const printWindow = window.open("", "_blank", "width=800,height=600");

  // Check if the print window is opened successfully
  if (printWindow) {
    // Get the content inside receiptContainer using .innerHTML, or you can use a more specific approach like querySelector
    const receiptElement = this.$refs.receiptContainer as HTMLElement;

    // You can extract the entire HTML of the container or filter out specific sections
    const printContents = receiptElement.innerHTML;

    // Styles for the printed receipt
    const styles = `
      <style>
        @page { size: 80mm; margin: 0; }
        body { font-family: Arial, sans-serif; margin: 0; padding: 5px; font-size: 14px; }
        .center { text-align: center; }
        .left { text-align: left; }
        .right { text-align: right; }
        .bold { font-weight: bold; }
        .double-size { font-size: 1.5em; }
        .divider { border-top: 1px dashed #000; margin: 10px 0; }
        @media print {
          body {
            width: 80mm; /* Adjust for receipt size */
            margin: 0;
            padding: 0;
            font-size: 12px;
          }
        }
      </style>
    `;

    // Write the HTML and styles to the print window
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Receipt</title>
          ${styles}
        </head>
        <body>
          ${printContents}
        </body>
      </html>
    `);
    printWindow.document.close();

    // Ensure content is fully loaded before calling print
    printWindow.onload = function() {
      printWindow?.print();
      printWindow?.close(); // Optionally close the print window after printing
    };
  } else {
    console.error('Failed to open print window');
  }
}
  // Lifecycle hook (mounted equivalent)
  mounted() {
    this.updateReceiptNumberFromUrl();
    this.fetchReceiptData();
  }
}
